import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: 8,
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 4,
  gap: 8,
  '& > .MuiTypography-subtitle1': {
    color: spaceCadet[400],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '24px',
    fontSize: 14,
  },
  '& .MuiBox-root.content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,

    '& > .MuiBox-root': {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,

      ':not(:first-of-type)::before': {
        content: '\'\'',
        backgroundColor: spaceCadet[300],
        width: '100%',
        height: 1,
      },
    },
  },
});

export default StyledBox;
